import i18n from 'i18next';

/** Re-run i18n so assessment preview picks up branding translation overrides. */
export async function refreshI18nPreview() {
    const lng = i18n.language || 'en';
    try {
        await i18n.reloadResources(lng);
    } catch (e) {
        // reloadResources may be unavailable depending on backend setup
    }
    await i18n.changeLanguage(lng);
}
